import { ProgressSpinner } from "primereact/progressspinner";
import { Suspense } from "react";
import { useTranslation } from "@i18n/hooks";

import { GenerateCartLinkForm } from "./parts/generate-cart-link-form";
import { BaseScreen } from "../../components/base-screen";

export const GenerateCartLinkScreen = () => {
	const { t } = useTranslation("common");

	return (
		<BaseScreen title={t("generateCartLink.screenTitle")}>
			<Suspense fallback={<ProgressSpinner />}>
				<GenerateCartLinkForm />
			</Suspense>
		</BaseScreen>
	);
};
